module.exports = __webpack_public_path__ + "static/media/supplier-account.ae4ef5a0.svg";